import { render, staticRenderFns } from "./approveQuestionnaire.vue?vue&type=template&id=3be10918&"
import script from "./approveQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./approveQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./approveQuestionnaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports